import dynamic from "next/dynamic";
import { useRouter } from "next/router";
import { useEffect, useRef, useState } from "react";
import { CloudinaryImage } from "../../Atoms/Cloudinary";
import styles from "./styles.module.scss";

// Loaded on demand so Apollo (used by its mutation) stays out of the shared layout bundle.
const EbookModal = dynamic(() => import("./EbookModal"), { ssr: false });

export default function EbookStickyBox() {
  const router = useRouter();
  const stickyRef = useRef<HTMLDivElement>(null);

  const [isOpen, setIsOpen] = useState(false);
  const [hasOpened, setHasOpened] = useState(false);
  const openModal = () => {
    setHasOpened(true);
    setIsOpen(true);
  };
  const [hasTrigger, setHasTrigger] = useState(false);
  const [isPastTrigger, setIsPastTrigger] = useState(false);
  const [isPastFooter, setIsPastFooter] = useState(false);
  const [isManuallyClosed, setIsManuallyClosed] = useState(false);

  useEffect(() => {
    const trigger = document.querySelector("[data-ebook-sticky-trigger]");
    const footer = document.querySelector("[data-footer-ebook]");

    let triggerObserver: IntersectionObserver | null = null;
    let footerObserver: IntersectionObserver | null = null;

    setHasTrigger(false);
    setIsPastTrigger(false);
    setIsPastFooter(false);
    setIsManuallyClosed(false);

    if (trigger) {
      setHasTrigger(true);

      triggerObserver = new IntersectionObserver(
        ([entry]) => {
          setIsPastTrigger(!entry.isIntersecting);
        },
        { threshold: 0 },
      );

      triggerObserver.observe(trigger);
    }

    if (footer) {
      footerObserver = new IntersectionObserver(
        ([entry]) => {
          setIsPastFooter(entry.isIntersecting);
        },
        {
          threshold: 0,
          rootMargin: "0px 0px -100px 0px",
        },
      );

      footerObserver.observe(footer);
    }

    return () => {
      triggerObserver?.disconnect();
      footerObserver?.disconnect();
    };
  }, [router.asPath]);

  const isVisible =
    hasTrigger && isPastTrigger && !isPastFooter && !isManuallyClosed;

  if (!isVisible) return null;

  return (
    <>
      <div ref={stickyRef} className={styles.stickyBox}>
        <button
          className={styles.stickyCloseBtn}
          onClick={() => setIsManuallyClosed(true)}
        >
          ×
        </button>

        <div className={styles.stickyBoxContent}>
          <h5>Japan Food Guide Ebook 🍜</h5>
          <p>60 local-approved spots.</p>

          <div className={styles.stickBoxImage}>
            <CloudinaryImage
              src="https://res.cloudinary.com/dbm1qiew0/image/upload/v1772504651/ebook/ebook-sticky.png"
              transformations={["h_200"]}
              objFit="inherit"
            />
          </div>

          <button onClick={openModal}>Get Free Guide</button>
        </div>
      </div>

      {/* Mounted on first open, so the modal's chunk (with Apollo) isn't fetched with the page. */}
      {hasOpened && (
        <EbookModal open={isOpen} onClose={() => setIsOpen(false)} />
      )}
    </>
  );
}
